import { render } from "./IconGiver.vue?vue&type=template&id=1d77f23d"
import script from "./IconGiver.vue?vue&type=script&lang=js"
export * from "./IconGiver.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__